import { type History } from "history";

import { type TrackerMethods } from "../types";

export const DummyAdapter = (): TrackerMethods => {
  const init: TrackerMethods["init"] = (_history: History) => {
    return false;
  };
  const setUserData: TrackerMethods["setUserData"] = _userData => void {};
  const captureException: TrackerMethods["captureException"] = (_e: Error) => undefined;

  return {
    captureException,
    init,
    setUserData,
  };
};
